const host = window.location.host

const getCurrentEnv = () => {
    if (host.indexOf('asjlx.com') === -1) {
        return 'test'
    }
    return 'prd'
}

const getBaseUrlAuction = () => {
    const env = getCurrentEnv()
    let baseURL = 'https://paimai.asjlx.com/home/api'
    if (env !== 'prd') {
        baseURL = 'https://houtai.iov.me/home/api' 
    }
    return baseURL
}

const getBaseUrlAdmin = () => {
    const env = getCurrentEnv()
    let baseURL = 'https://admin.asjlx.com/'
    if (env !== 'prd') {
        baseURL = 'https://admin.asjlx.com/' 
    }
    return baseURL
}


export default {
    baseUrlAuction: getBaseUrlAuction(),
    baseUrlAdmin: getBaseUrlAdmin(),
    ENV: getCurrentEnv()
}

